












































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  members,
  updateRole,
  deleteMember,
  groupList,
  changeGroup,
  updateExplain,
  exportMembers,
} from "@/api/team/team";
import { SERVER_HOST } from "@/global/constants";
import axios from "axios";

@Component
export default class Member extends Vue {
  private loading = false;
  private medalShow = false;
  private statusList = [
    {
      value: "",
      label: "全部",
    },
    {
      value: "0",
      label: "初级标注员",
    },
    {
      value: "2",
      label: "高级标注员",
    },
    {
      value: "3",
      label: "审核员",
    },
    {
      value: "4",
      label: "高级审核员",
    },
    {
      value: "5",
      label: "小助手",
    },
    {
      value: "6",
      label: "质检员",
    },
  ];

  private groupList: object[] = [];

  private dataList: object[] = [];
  private medalList: object[] = [];

  private total: number | string = 0;
  private experienceCategory: any = [];
  private roleCount: string = "";
  // 备注
  private formExplain: object = {
    explain: "",
    uid: "",
  };
  private visibleExplain: boolean = false;
  private searchParams: object = {
    uid: "",
    sctime: "",
    ectime: "",
    role: "",
    min_amount: "",
    max_amount: "",
    page: 1,
    pagesize: 20,
    group_id: "",
  };
  private medalColumns: object[] = [
    {
      title: "ID",
      key: "id",
      align: "center",
      fixed: "left",
      width: 50,
    },
    {
      title: "类型",
      slot: "type",
      key: "type",
      align: "center",
      fixed: "left",
      width: 100,
    },
    {
      title: "名称",
      key: "title",
      align: "center",
      fixed: "left",
      width: 180,
    },
    {
      title: "获得时间",
      slot: "time",
      align: "center",
      fixed: "left",
      key: "time",
      width: 160,
    },
  ];
  private columnsSchema: object[] = [
    {
      title: "小队",
      key: "group_name",
      align: "center",
      width: 100,
    },
    {
      title: "小队ID",
      key: "group_id",
      align: "center",
      slot: "format_id",
      width: 100,
    },
    {
      title: "角色",
      key: "role_name",
      align: "center",
      width: 100,
    },
    {
      title: "头像",
      slot: "url",
      align: "center",
      width: 70,
    },
    {
      title: "成员ID",
      key: "uid",
      width: 100,
    },
    {
      title: "昵称",
      key: "nick_name",
      width: 120,
    },
    {
      title: "真实姓名",
      key: "real_name",
      width: 100,
    },
    {
      title: "操作",
      slot: "operate",
      align: "center",
      width: 200,
    },
    {
      title: "通过时间",
      slot: "time",
      align: "center",
      width: 120,
    },
    {
      title: "本月产值（元）",
      key: "month_amount",
      align: "center",
      width: 100,
    },
    {
      title: "备注",
      key: "explain",
      align: "center",
      width: 180,
    },
    {
      title: "获取勋章数量",
      slot: "medal",
      align: "center",
      width: 180,
    },
  ];
  private created() {
    this.getList();
    this.getGroupList();
  }

  private openMedal(list) {
    this.medalShow = true;
    this.medalList = list;
  }

  private async getGroupList() {
    try {
      const data = (await groupList()) as any;
      this.$nextTick(() => {
        this.groupList = data.result;
      });
    } catch (error) {
      console.log(error);
    }
  }

  private async getList() {
    this.loading = true;
    let params: any = JSON.parse(JSON.stringify(this.searchParams));

    try {
      const data = (await members(params)) as any;
      this.loading = false;
      this.$nextTick(() => {
        this.dataList = data.rows;
        this.total = data.total;
        this.roleCount = data.roleCount;
      });
    } catch (error) {
      console.log(error);
      this.loading = false;
    }
  }

  // 搜索
  private handleSearch() {
    this.getList();
  }
  // 导出
  private exports() {
    exportMembers(JSON.stringify(this.searchParams)).then((res) => {
      // debugger
      // const fileName = 'member.xls'
      // const blob = (new Blob([(res as any).data], {type: 'application/octet-stream'})) as any
      // let dom = document.createElement('a')
      // let url = window.URL.createObjectURL(blob)
      // dom.href = url
      // dom.download = decodeURI(fileName)
      // dom.style.display = 'none'
      // document.body.appendChild(dom)
      // dom.click()
      // dom.parentNode.removeChild(dom)
      // window.URL.revokeObjectURL(url)
      const blob = new Blob([res as any], { type: "application/vnd.ms-excel" });
      //创建一个空的 a 标签
      let a = document.createElement("a");
      // 将 blob 文件转化为 url 格式并赋值给a标签的 href 属性
      a.href = URL.createObjectURL(blob);
      // 给a标签设置下载链接并命名
      a.setAttribute("download", "excel.xls");
      // 点击事件触发 href
      a.click();
      // 清除 a 标签
      a = null;
    });
  }
  // 开始日期选择器
  private stimeChange(date) {
    (this.searchParams as any).sctime = date;
  }
  // 开始日期选择器
  private etimeChange(date) {
    (this.searchParams as any).ectime = date;
  }
  // 分页
  private changePage(data) {
    this.searchParams = Object.assign(this.searchParams, {
      page: data,
    });
    this.getList();
  }
  // 重置
  private handlereset() {
    this.searchParams = {
      uid: "",
      sctime: "",
      ectime: "",
      role: "",
      min_amount: "",
      max_amount: "",
      page: 1,
      pagesize: 20,
      group_id: "",
    };
    this.getList();
  }
  // 查看 功能取消
  private handleExp() {}
  //剔除
  private handleDeleteMember(row) {
    this.$Modal.confirm({
      title: "剔除成员",
      content: `您确定要剔除成员【${row.nick_name}】吗？`,
      onOk: () => {
        this.deleteTeamMember(row.uid);
      },
    });
  }
  private async deleteTeamMember(uid) {
    let res = await deleteMember({ uid: uid });
    this.getList();
  }

  //更改角色弹出
  private handleUpdateRole(row) {
    this.$Modal.confirm({
      title: `修改用户 【` + row.nick_name + `(ID:` + row.uid + `)】 角色`,
      content: `<div>
                              <select name="role" id="role_select" >
                                <option value="0">初级标注员</option>
                                <option value="2">高级标注员</option>
                                <option value="3">审核员</option>
                                <option value="4">高级审核员</option>
                                <option value="5">小助手</option>
                                <option value="6">质检员</option>
                              </select>
                            </div>`,
      okText: "确定",
      cancelText: "取消",
      onOk: () => {
        let oOpt: any = document.getElementById("role_select");
        this.updateRole(row, oOpt);
      },
    });
  }

  //更改角色弹出
  private handleUpdateGroup(row) {
    let option = "";
    this.groupList.forEach((item) => {
      if (row.group_id && (item as any).group_id == row.group_id) {
        option =
          option +
          "<option selected value='" +
          (item as any).group_id +
          "'>" +
          (item as any).name +
          "</option>";
      } else {
        option =
          option +
          "<option value='" +
          (item as any).group_id +
          "'>" +
          (item as any).name +
          "</option>";
      }
    });
    this.$Modal.confirm({
      title: `修改用户 【` + row.nick_name + `(ID:` + row.uid + `)】小队`,
      content:
        `<div>
                              <select name="group" id="group_select" >
                                <option value="">无</option>
                                ` +
        option +
        `
                              </select>
                            </div>`,
      okText: "确定",
      cancelText: "取消",
      onOk: () => {
        this.updateGroup(row);
      },
    });
  }

  private handleUpdateExplain(row) {
    this.formExplain = {
      uid: row.uid || "",
      explain: row.explain || "",
    };
    this.visibleExplain = true;
  }
  // 隐藏modal
  private handleExplainCancel() {
    this.visibleExplain = false;
  }

  //更改备注e
  private async updateExplain() {
    let res = await updateExplain(this.formExplain);
    this.visibleExplain = false;
    this.getList();
  }
  // 角色更改
  private async updateRole(row, oOpt) {
    if (row.role == "3" || row.role == "4") {
      setTimeout(() => {
        this.$Modal.confirm({
          title: "提示",
          content: `用户退出审核员，30天内不能再加回来，确定修改吗`,
          okText: "确定",
          cancelText: "取消",
          onOk: () => {
            let val = oOpt.options[oOpt.selectedIndex].value;
            const res: any = updateRole({ uid: row.uid, role: val });

            if (res.message) {
              setTimeout(() => {
                this.$Modal.error({
                  title: "更改失败",
                  content: res.message,
                });
              }, 500);
            } else {
              this.getList();
            }
          },
        });
      }, 500);
    }
    if (row.role == "5") {
      setTimeout(() => {
        this.$Modal.confirm({
          title: "提示",
          content: `用户退出质检员，6个月内不能再加回来，确定修改吗`,
          okText: "确定",
          cancelText: "取消",
          onOk: () => {
            let val = oOpt.options[oOpt.selectedIndex].value;
            const res: any = updateRole({ uid: row.uid, role: val });
            if (res.message) {
              setTimeout(() => {
                this.$Modal.error({
                  title: "更改失败",
                  content: res.message,
                });
              }, 500);
            } else {
              this.getList();
            }
          },
        });
      }, 500);
    } else {
      let oOpt: any = document.getElementById("role_select");
      let val = oOpt.options[oOpt.selectedIndex].value;
      const res: any = await updateRole({ uid: row.uid, role: val });
      if (res.message) {
        setTimeout(() => {
          this.$Modal.error({
            title: "更改失败",
            content: res.message,
          });
        }, 500);
      } else {
        this.getList();
      }
    }
  }

  private async updateGroup(row) {
    let oOpt: any = document.getElementById("group_select");
    let val = oOpt.options[oOpt.selectedIndex].value;
    if (val == "") {
      val = null;
    }

    let res = (await changeGroup({ uid: row.uid, group_id: val })) as any;
    if (res.code == 200) {
      this.getList();
    } else {
      this.$Message.success(res.message);
    }
  }

  private formatGroupId(data) {
    if (data.group_id) {
      return data.id + "-" + data.group_id;
    } else {
      return "";
    }
  }
}
